import { useState, useEffect } from 'react'
import {
  CognitoUserPool,
  CognitoRefreshToken,
} from 'amazon-cognito-identity-js'

import awsConfiguration from '@/lib/awsconfiguration'
import { removeLocalStorage } from '@/lib/removeLocalstorage'
import { format } from 'date-fns'
import md5 from 'js-md5'
import { decodeJwt } from '@/lib/decodeJwt'

const userPool = new CognitoUserPool({
  UserPoolId: awsConfiguration.UserPoolId,
  ClientId: awsConfiguration.ClientId,
})

export async function useCustumHooksFetchAll(array: string | any[]) {
  const cognitoUser = userPool.getCurrentUser()
  // alert(
  //   'timestamp : ' +
  //     format(new Date(), 'mm:ss') +
  //     ' : useF 15 / cognitoUser : ' +
  //     JSON.stringify(cognitoUser)
  // )
  const arrayPromise = []
  const [ReturnData, setReturnData] = useState(undefined) as any
  const [ArrayPromise, setArrayPromise] = useState() as any

  const Fetch = async (url: string, token: string) => {
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Authorization': token,
          'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        },
      })

      const res = await response.json()

      // alert(
      //   'timestamp : ' +
      //     format(new Date(), 'mm:ss') +
      //     ': useF 41 : ' +
      //     JSON.stringify(res)
      // )

      // alert(
      //   'timestamp : ' +
      //     format(new Date(), 'mm:ss') +
      //     ' : useF 48 : ' +
      //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt : AccessToken / ` +
      //     token +
      //     ' : md5変換 /' +
      //     md5(token)
      // )

      // const decode = decodeJwt(token)
      // alert('デコードJWT : ' + JSON.stringify(decode))

      if (res.status === 400) {
        removeLocalStorage()
        // cognitoUser.signOut()
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
        return
      }

      if (res.status === 401) {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Authorization': token,
            'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
          },
        })

        const resultReFetch = await response.json()

        if (resultReFetch.status === 200) {
          return res
        }

        if (resultReFetch.status === 401) {
          location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
        }
      }

      if (response.status === 200) {
        return res
      }
    } catch (error) {
      return await Promise.reject(error)
    }
  }

  useEffect(() => {
    // const refreshTokenCognitoFetch = async (refresh_token) => {
    //   const Params = Object.entries({
    //     grant_type: 'refresh_token',
    //     client_id: awsConfiguration.ClientId,
    //     redirect_uri: window.location.origin,
    //     refresh_token: refresh_token,
    //   })
    //     .map(([k, v]) => `${k}=${v}`)
    //     .join('&')

    //   const refreshTokenCognitoFetchResult = await fetch(
    //     'https://raund-stg.auth.ap-northeast-1.amazoncognito.com/oauth2/token',
    //     {
    //       method: 'POST',
    //       //mode: 'no-cors',
    //       headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //       },
    //       body: Params,
    //     }
    //   )

    //   if (!refreshTokenCognitoFetchResult.ok) {
    //     throw new Error(await refreshTokenCognitoFetchResult.json())
    //   }

    //   const newTokens = await refreshTokenCognitoFetchResult.json()

    //   for (let i = 0; i <= array.length - 1; i++) {
    //     arrayPromise.push(Fetch(array[i], newTokens.access_token))
    //   }

    //   localStorage.setItem(
    //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
    //     newTokens.access_token
    //   )

    //   setArrayPromise([])
    //   setArrayPromise(arrayPromise)
    // }

    const exp =
      Number(
        localStorage.getItem(
          `${process.env.NEXT_PUBLIC_SERVICE_NAME}-exp-token`
        )
      ) * 1000
    const now = new Date().getTime()

    if (cognitoUser != null) {
      if (now > exp) {
        // refreshTokenCognitoFetch(
        //   localStorage.getItem(
        //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh-jwt`
        //   )
        // )

        cognitoUser.getSession((err: any, session: any) => {
          const refresh_token = session.getRefreshToken()

          cognitoUser.refreshSession(refresh_token, (err, session) => {
            if (session.isValid()) {
              // alert(
              //   'useF : ' +
              //     format(new Date(), 'mm:ss') +
              //     ' : 更新！！JWT Token Name : ' +
              //     `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
              // )

              // alert(
              //   'useF : ' +
              //     format(new Date(), 'mm:ss') +
              //     ' : 更新！！access token : ' +
              //     JSON.stringify(session.getAccessToken().getJwtToken()) +
              //     ' :  md5変換 / ' +
              //     md5(session.getAccessToken().getJwtToken())
              // )

              for (let i = 0; i <= array.length - 1; i++) {
                arrayPromise.push(
                  Fetch(array[i], session.getAccessToken().getJwtToken())
                )
              }

              localStorage.setItem(
                `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`,
                session.getAccessToken().getJwtToken()
              )

              localStorage.setItem(
                `${process.env.NEXT_PUBLIC_SERVICE_NAME}-exp-token`,
                session.accessToken.payload.exp
              )

              setArrayPromise([])
              setArrayPromise(arrayPromise)
            }
          })
        })
      } else {
        for (let i = 0; i <= array.length - 1; i++) {
          arrayPromise.push(
            Fetch(
              array[i],
              localStorage.getItem(
                `${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`
              )
            )
          )
        }

        setArrayPromise([])
        setArrayPromise(arrayPromise)
      }
      return
    }

    removeLocalStorage()
  }, [])

  useEffect(() => {
    if (ArrayPromise !== undefined) {
      Promise.all(ArrayPromise)
        .then((res) => {
          return res
        })
        .then((res) => {
          if (res !== undefined) {
            // @ts-ignore
            if (res.length === 0) {
              throw new Error('Whoops!')
            } else {
              setReturnData(res)
            }
          }
        })
        .catch((err) => {
          // setData(err)
          Promise.all(ArrayPromise)
            .then((res) => {
              return res
            })
            .then((res) => {
              setReturnData(res)
            })
            .catch((err) => {
              // setData(err)
              console.error(err)
            })
        })
    }
    return
  }, [ArrayPromise])

  return ReturnData
}
